var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5857 5H5.41411C4.52321 5 4.07704 6.07714 4.70701 6.70711L9.70701 11.7071C9.89454 11.8946 9.9999 12.149 9.9999 12.4142V16.5C9.9999 16.8148 10.1481 17.1111 10.3999 17.3L13.1999 19.4C13.5295 19.6472 13.9999 19.412 13.9999 19V12.4142C13.9999 12.149 14.1053 11.8946 14.2928 11.7071L19.2928 6.70711C19.9228 6.07714 19.4766 5 18.5857 5Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.5a0bc6299bb1ed813061354dfe58f668.svg";
export { ForwardRef as ReactComponent };